import React from "react";
import "whatwg-fetch";
import {URLs, GENERIC_ERROR_MESSAGE} from "./constants";
import {translate} from "../i18n/translate";

export const PATH_IMAGES = "/site/store/images/";
export const MAX_DATE_IN_SERVER_FORMAT = "3000-01-01";

export function ajax(fetchUrl, data) {
	return fetch(fetchUrl, {
		credentials: 'same-origin',
		method: 'POST',
		body: parametrize(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		}
	}).then(checkResponseStatus)
		.then(response => {
		    return new Promise((resolve, reject) => {
		        response.json().then(json => {
                    if (json.error)
                        reject (json.error);
                    resolve(json);
                })
            })
        });
}

export function parametrize (a) {
    const s = [], rbracket = /\[\]$/,
        isArray = function (obj) {
            return Object.prototype.toString.call(obj) === '[object Array]';
        }, add = function (k, v) {
            v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
            s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
        }, buildParams = function (prefix, obj) {
            let i, len, key;

            if (prefix) {
                if (isArray(obj)) {
                    for (i = 0, len = obj.length; i < len; i++) {
                        if (rbracket.test(prefix)) {
                            add(prefix, obj[i]);
                        } else {
                            buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
                        }
                    }
                } else if (obj && String(obj) === '[object Object]') {
                    for (key in obj) {
                        if(obj.hasOwnProperty(key)) {
                            buildParams(prefix + '[' + key + ']', obj[key]);
                        }
                    }
                } else {
                    add(prefix, obj);
                }
            } else if (isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    add(obj[i].name, obj[i].value);
                }
            } else {
                for (key in obj) {
                    if(obj.hasOwnProperty(key)) {
                        buildParams(key, obj[key]);
                    }
                }
            }
            return s;
        };

    return buildParams('', a).join('&').replace(/%20/g, '+');
}

function checkResponseStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    } else {
        let error = new Error(response.statusText) ;
        error.response = response;
        error.suppress = response.status >= 500 || response.status === 0;
        throw error;
    }
}

export function checkResponseOKStatus(response) {
    if (response.statusCode === "OK")
        return true;
    const message = response.message ? response.message : GENERIC_ERROR_MESSAGE;
    throw new Error (message);
}

export function getPageContext(){
    const page = location.pathname.split('/')[1];
    for (const url in URLs)
        if (URLs.hasOwnProperty(url) && URLs[url] === page)
            return URLs[url];
    return undefined;
}

export function getUrlParams() {
    const searchParams = location.search.substr(1);
    if (searchParams.length === 0)
        return {};
    let params = {};
    const paramsArr = searchParams.split("&");
    paramsArr.map(p => {
        const param = p.split("=");
        params[param[0]] = decodeURIComponent(param[1]);
    });
    return params;
}

export function addPath(path) {
    if (location.pathname.endsWith(path))
        return location.pathname;
	return location.pathname+(location.pathname.endsWith('/')?'':'/')+path + location.hash;
}

export function removePath(path, fullPath) {
    let locationPath = fullPath?fullPath:location.pathname;
	return locationPath.endsWith(path)
        ?locationPath.replace(path,'') + location.search
        :locationPath + location.search;
}

export function replacePath(path) {
	let pathname = location.pathname;
	if (pathname.endsWith('/')) {
		pathname = pathname.slice(0, pathname.length-1);
	}
	return pathname.slice(0, pathname.lastIndexOf('/')+1)+ path + location.hash;
}

export function redirectPage(to, staticData, suffix) {
    return window.location.origin + "/" + to + "/" + staticData.farmUrl + "/" + staticData.seasonUrl + (suffix ? suffix : '');
}

export const objectUtils = {
    isNumber: function(obj) {
        return typeof obj === 'number';
    },
	isString: function(obj) {
        return typeof obj === 'string';
	},
	isArray: function(obj) {
        return Array.isArray(obj);
	},
    isFunction: function(obj) {
        return typeof obj === 'function';
    }
};

export function validateEmail(email) {
    const regex = (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regex.test(email);
}

export function validateZipCode(zipCode, country) {
    const regex = country==='CA'?(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i):(/^\d{5}(-\d{4})?$/);
    return regex.test(zipCode);
}

export function signOutPath() {
    let location = window.location.pathname;
    if (location.endsWith('/thankyou')) {
        location = removePath('/thankyou');
    }
    return location;
}

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export function getUsefulDate(usefulDate) {
    if(usefulDate) {
        const date = _parseFromServerDate(usefulDate);
        const day = date.getDay();
        const month = date.getMonth();

        return translate(days[day]) + ', ' + translate(months[month]) + ' ' + date.getDate();
    }
}

export function getUsefulDateWithYear(usefulDate, isMobile) {
    if(usefulDate) {
        const date = _parseFromServerDate(usefulDate);
        let fullYear = date.getFullYear();
        if (isMobile) {
            fullYear = fullYear - 2000;
        }
        return translate(months[date.getMonth()]) + ' ' + date.getDate() + ', ' + fullYear;
    }
}

function _parseFromServerDate (serverDate) {
    if (serverDate) {
        const elements = serverDate.split(/-/g);
        return new Date(elements[0], elements[1] - 1, elements[2]);
    } else {
        return null;
    }
}

export function formatToServerDate(date) {
    if (!(date instanceof Date))
        return '';

    return date ? date.getFullYear() + '-' + _pad(date.getMonth() + 1, 2) + '-' + _pad(date.getDate(), 2) : '';
}

export function getDiffFromNow(serverDate) {
    const date = _parseFromServerDate(serverDate);
    if (date) {
        return date.getTime() - new Date().getTime();
    }
    return 0;
}

function _pad (number, length) {
    return ('0000000000' + number).slice(-length);
}

export function addCookie(name, value, expirationDate){
    document.cookie = name + "=" + value + "; expires="+expirationDate+"; path=/";
}

export function getCookie(cname){
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}

export function deleteCookie(cname){
    document.cookie = cname+"=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

export function initFacebook(facebookAppId, forceReload, callback) {
    window.fbAsyncInit = function() {
        FB.init({
            appId      : facebookAppId,
            cookie     : true,  // enable cookies to allow the server to access
            xfbml      : false,  // don't parse social plugins on this page
            version    : 'v11.0' // use version 11.0
        });
        if (typeof callback == 'function') {
            callback();
        }
        // }.bind(this);
    };

    (function(d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id) && !forceReload) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}

export function isEmptyObj(obj) {
    if(obj) {
        return Object.keys(obj).length === 0;
    } else {
        return true;
    }
}

export function isEmptyString(str) {
    return !str || str === ""
}

export function geocodeAddress(address, delay) {
    const geoCoder = new google.maps.Geocoder();
    let lat, lng;
    return new Promise(resolve =>
    {setTimeout(()=>
    { return geoCoder.geocode({'address': address}, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                lat = results[0].geometry.location.lat();
                lng =  results[0].geometry.location.lng();
                resolve({
                    lat,
                    lng,
                    status
                })
            } else {
                resolve({
                    address,
                    results,
                    status
                })
            }
        });
    }, delay?delay:0);});
}

export function isValidPhoneNumber(phone) {
    return (/^\s*\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})\s*$/).test(phone);
}

export function compareArrays(array1, array2) {
    if(array1.length !== array2.length) {
        return false;
    }
    return array1.every(function(element, index){
        return element.key === array2[index].key;
    }) ;
}

export function compareZipCodes(zipCode1, zipCode2) {
    if(isEmptyObj(zipCode1) || isEmptyObj(zipCode2)) {
        return zipCode1 === zipCode2;
    } else {
        return zipCode1.lat === zipCode2.lat && zipCode1.lng === zipCode2.lng;
    }
}

export function setNoItemImage(event) {
    event.target.src = "/site/store/react/src/images/item-no-image.jpg";
}



// WEBPACK FOOTER //
// ./src/common/utils.js